import { createSlice } from "@reduxjs/toolkit";
import {
  assignRdpToUser,
  assignUsertordp,
  blockRdp,
  getAllRdps,
  saveNewRdps,
  updateRdps,
} from "../actions/rdp";

export const rdpsSlice = createSlice({
  name: "rdps",
  initialState: {
    loading: false,
    rdpsList: [],
    totalcount: 0,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get All Rdps
      .addCase(getAllRdps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllRdps.fulfilled, (state, action) => {
        state.loading = false;
        const { result, totalDocument } = action.payload;

        state.rdpsList = result;
        state.totalcount = totalDocument;
      })
      .addCase(getAllRdps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //assignRdpToUser
      .addCase(assignRdpToUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignRdpToUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(assignRdpToUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //assignUsertordp
      .addCase(assignUsertordp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignUsertordp.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(assignUsertordp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //saveNewRdps
      .addCase(saveNewRdps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNewRdps.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveNewRdps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //updateRdps
      .addCase(updateRdps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRdps.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateRdps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //blockRdp
      .addCase(blockRdp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(blockRdp.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(blockRdp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default rdpsSlice.reducer;
